module.exports = __webpack_public_path__ + "static/media/empty.1e060a34.svg";